import { IGetDiagnosticServiceabilityPayload } from "../../interfaces/api/fuse/getDiagnosticServiceability"
import ApiUtils from "../ApiUtils"
import { IFuseService } from "./IFuseService"

const FuseUrls = {
	diagnosticSeviceablity: ({ zipCode, latitude, longitude }: IGetDiagnosticServiceabilityPayload) =>
		`/fuse/v2/diagnostic/serviceability?longitude=${longitude}&latitude=${latitude}&zipCode=${zipCode}`,
	diagnosticProductByCode: (code: string) => `/fuse/v1/diagnostic/products/product?code=${encodeURIComponent(code)}`,
}

export default class FuseServiceApis implements IFuseService {
	getServiceUrl = (path: string): string => {
		return "/fuse" + path
	}

	getDiagnosticServiceability = (payload: IGetDiagnosticServiceabilityPayload): Promise<any> => {
		const url = this.getServiceUrl(FuseUrls.diagnosticSeviceablity(payload))
		return ApiUtils.get(url)
	}

	getDiagnosticProductByCode = (code: string): Promise<any> => {
		const url = this.getServiceUrl(FuseUrls.diagnosticProductByCode(code))
		return ApiUtils.get(url)
	}
}
